import { BASE_URL } from "../utils/Constant.jsx";
import { store } from "../app/store.jsx";
import { performLogout } from "./utils.jsx";
import { refreshAccessToken } from "../api/api.js";

let isRefreshing = false;
let requestQueue = [];

const processQueue = (error, token = null) => {
  requestQueue.forEach(({ resolve, reject, originalRequest }) => {
    if (token) {
      resolve(fetchWithAuth(originalRequest, token));
    } else {
      reject(error);
    }
  });
  requestQueue = [];
};

const fetchWithAuth = async (options, token = store.getState().auth.accessToken) => {
  const { method = "GET", endpoint, data, customParams = {}, headers = {}, retry = false } = options;
  token = token || store.getState().auth.accessToken;
  let url = new URL(`${BASE_URL}${endpoint}`);
  if ((method === "GET" || method === "DELETE") && customParams) {
    Object.entries(customParams).forEach(([key, value]) =>
      url.searchParams.append(key, value)
    );
  }
  const finalHeaders = {
    ...headers,
    ...(token && { Authorization: `Bearer ${token}` }),
  };

  let body;
  if (data instanceof FormData) {
    body = data;
  } else if (data) {
    body = JSON.stringify(data);
    finalHeaders["Content-Type"] = "application/json";
  }

  const response = await fetch(url.toString(), {
    method,
    headers: finalHeaders,
    body: method !== "GET" && method !== "DELETE" ? body : undefined,
  });

  if (response.status === 401 && !retry) {
    const refreshToken = store.getState().auth.refreshToken;
    if (!refreshToken) {
      performLogout();
      throw new Error("Unauthorized - no refresh token");
    }

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        requestQueue.push({ resolve, reject, originalRequest: { ...options, retry: true } });
      });
    }
    isRefreshing = true;
    try {
      const newAccessToken = await refreshAccessToken(refreshToken);
      processQueue(null, newAccessToken);
      return fetchWithAuth({ ...options, retry: true }, newAccessToken);
    } catch (err) {
      processQueue(err, null);
      performLogout();
      throw err;
    } finally {
      isRefreshing = false;
    }
  }
  if (!response.ok) {
    const error = await response.text();
    throw new Error(error || "Request failed");
  }
  return response.json();
};
export default fetchWithAuth;
